module.exports = __webpack_public_path__ + "img/31_13.577235f4.png";